import { useState } from "react";
import useAuthStore from "./states/authStore";
import { usePageTransition } from "@iq/models";
import { AUTH_BASE_URL } from "./services/authApi";
import { AnimatedReveal } from "@iq/models"
import Iridescence from "./components/Iridescence/Iridescence";
import "./styles/Login.css";
import { login } from "./services/authApi";


function Login() {
  const revalidateSession = useAuthStore((state) => state.revalidateSession);
  // const { runTransition } = usePageTransition();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      await login(email.trim(), password);
      // Pull the full session DTO (org, role, permitted apps) rather than the login response.
      if (!(await revalidateSession())) {
        throw new Error("Could not load session after login");
      }

      // await runTransition({
      //   to: "/",
      //   replace: true,
      // });
    } catch (err) {
      setError(err.message || "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <AnimatedReveal stagger={100} duration={600}>
      <section className="login-wrap">

          <aside className="login-aside">
            <Iridescence
              color="#6e9180"
              hueShift={0}
              saturation={1}
              brightness={1.7}
              contrast={0.6}
              speed={0.35}
              scale={1}
              detail={6}
              warp={1}
              rotation={0}
            />
            {/* <div className="login-aside-content">
              <div className="login-aside-header">
                  <h1>Striver</h1>
                  <p>By IQVentory</p>
              </div>
              <div>
                <h3>Your connected workspace starts here.</h3>
              </div>
            </div> */}

          </aside>
          <div className="login-card">
            <div className="login-card-content">
              <div className="login-header" data-reveal>
                <h2 className="login-title">Hey there,</h2>
                <p className="login-subtitle">Sign in below to access your Striver dashboard.</p>
              </div>
              <form onSubmit={onSubmit} className="login-form" id="login-form">
                <div className="login-field" data-reveal>
                  <label htmlFor="email">Email</label>
                  <input
                    className="login-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    autoComplete="email"
                  />
                </div>

                <div className="login-field" data-reveal>
                  <label htmlFor="password">Password</label>
                  <input
                    className="login-input"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    autoComplete="current-password"
                  />
                </div>
              </form>
              <div className="login-actions" data-reveal>
                <button className="login-button" type="submit" form="login-form" disabled={loading || !email.trim() || !password}>
                  {loading ? "Signing in..." : "Sign in"}
                </button>
                <a href="/forgot-password" className="login-forgot-password">Forgot password?</a>
                {error ? <p className="login-error">{error}</p> : null}
              </div>
            </div>
          </div>
      </section>
    </AnimatedReveal>
  );
}

export default Login;
